// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    codeData: null
  },
  mutations: {
    setCodeData(state, data) {
      state.codeData = data;
    }
  },
  actions: {
    updateCodeData({ commit }, data) {
      commit('setCodeData', data);
    }
  },
  getters: {
    getCodeData: state => state.codeData
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js